/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_appsync_graphqlEndpoint": "https://m5dlutatrzf4dgcnkocaq4uaeu.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-afvq5p2sujfivlikgtzdclnvni",
    "aws_cognito_identity_pool_id": "ap-south-1:1bffe45d-8b30-4212-8fb3-e80238114d5d",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_rO3lriUnj",
    "aws_user_pools_web_client_id": "jrjavt9c35fuc4hf976kmh5m3",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "GIVEN_NAME",
        "FAMILY_NAME"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_user_files_s3_bucket": "scrappy-afe2cd64144028-staging",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
